"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidUSZip = isValidUSZip;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
function isValidUSZip(sZip) {
  return /^\d{5}(-\d{4})?$/.test(sZip);
}